import {
  THEME_CONFIG as THEME_CONFIG_LIB,
  type ThemeName,
  type ThemeVariableConfig,
} from "@krainovsd/vue-ui";

export const THEME_CONFIG: Record<ThemeName, ThemeVariableConfig> = {
  light: {
    ...THEME_CONFIG_LIB.light,
    // custom variables for light here
    custom: {
      radius: "0.625rem",
    },
  },
  dark: {
    ...THEME_CONFIG_LIB.dark,
    // custom variables for dark here
    custom: {
      "ksd-accent-hover-color": "oklch(0.943 0.196 102.85)",
      "ksd-radio-dot-color": "black",
      "ksd-bg-color": "oklch(0.155 0.005 102)",
      "ksd-divider-color": "oklch(1 0.006 102/10%)",
      "ksd-text-reverse-color": "oklch(0.205 0.006 102)",
      "ksd-accent-color": "oklch(0.92 0.005 102)",
      "ksd-font-family": "Onest",
      "ksd-table-body-bg": "oklch(0.205 0.006 102)",
      "ksd-table-header-bg": "oklch(0.205 0.006 102)",
      "ksd-table-row-bg": "oklch(0.205 0.006 102)",
      "muted-foreground": "oklch(0.7 0.005 102)",
      foreground: "oklch(0.97 0.004 102)",
      // background: "oklch(0.155 0.005 102)",
      card: "oklch(0.205 0.006 102)",
      "card-translucent": "oklch(0.205 0.006 102 / 0.6)",
      popover: "oklch(0.215 0.006 102)",
      border: "oklch(1 0.006 102 / 10%)",
      "border-subtle": "oklch(1 0.006 102 / 0.06)",
      brand: "oklch(0.943 0.196 102.85)",
      "brand-foreground": "oklch(0.205 0.006 102)",
      success: "oklch(0.72 0.17 145)",
      destructive: "oklch(0.704 0.191 22.216)",
      radius: "0.625rem",
      warning: "oklch(0.82 0.16 75)",
      secondary: "oklch(0.265 0.006 102)",
    },
  },
};

export const PAGES = {
  Statistics: "statistics",
  Report: "report",
  ReportByFilters: "report-by-filters",
  CreateReport: "create-report",
  Briefs: "briefs",
  Brief: "brief",
  Compare: "compare",
  CreateComparison: "create-comparison",
  FactorComparison: "factor-comparison",
  BayesianCompare: "bayesian-compare",
  Account: "account",
  Subscription: "subscription",
  CreateSubscription: "create-subscription",
  EditSubscription: "edit-subscription",
  Error: "error",
  Denied: "denied",
};
